import Vue from "vue";
import Component from "vue-class-component";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CookieToast" })
export default class CookieToast extends Vue {
    public localizer: any = Localizer;
    public isCookieToast: boolean = false;
    public isCustomize: boolean = false;
    public isActivateStatistics: boolean = false;
    public isActivateProfiling: boolean = false;
    public cookieToastData: any = { cookiePolicyUrl: null };
    public customizeCookieValues: string[] = ["tech"];

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        if (!CookieHelper.isCookiePolicy()) {
            this.cookieToastData.cookiePolicyUrl = this.routes.UrlCookiePolicy;
            this.isCookieToast = true;
        }
    }

    public setCookieToast() {
        CookieHelper.setCookiePolicyAll();
        this.isCookieToast = false;

        window.location.reload();
    }

    public setOnlyTech() {
        CookieHelper.removeCookiePolicyAll();
        this.isCookieToast = false;

        window.location.reload();
    }

    public setCustomize() {
        this.isCustomize = !this.isCustomize;
    }

    public setStatistics() {
        this.isActivateStatistics = !this.isActivateStatistics;
        if (this.isActivateStatistics) {
            this.customizeCookieValues.push("stat");
        } else {
            const index = this.customizeCookieValues.indexOf("stat");
            if (index !== -1) {
                this.customizeCookieValues.splice(index, 1);
            }
        }
    }

    public setProfiling() {
        this.isActivateProfiling = !this.isActivateProfiling;
        if (this.isActivateProfiling) {
            this.customizeCookieValues.push("profile");
        } else {
            const index = this.customizeCookieValues.indexOf("profile");
            if (index !== -1) {
                this.customizeCookieValues.splice(index, 1);
            }
        }
    }

    public setCustomCookie() {
        CookieHelper.setCookie("ckp", this.customizeCookieValues.join("|"), 365);
        this.isCookieToast = false;
        
        window.location.reload();
    }
};
